import { InputHTMLAttributes, ReactNode } from 'react';
import { Label } from '../Label';
import { joinClassNames } from '../../../utils';
import styles from '../styles.module.scss';

export type TextInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'id' | 'size'> & {
  id: string;
  label: string;
  hideLabel?: boolean;
  isRequired?: boolean;
  containerClassName?: string;
  size?: TextInputSize;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
};

export enum TextInputSize {
  Small = 'small',
  Large = 'large',
}

export const TextInput = ({
  id,
  label,
  hideLabel = false,
  isRequired = false,
  className,
  containerClassName,
  size = TextInputSize.Large,
  startAdornment,
  endAdornment,
  ...props
}: TextInputProps) => {
  const sizeStyles = {
    [TextInputSize.Small]: styles.textInputSmall,
    [TextInputSize.Large]: styles.textInputLarge,
  };

  return (
    <div className={containerClassName}>
      <Label htmlFor={id} isRequired={isRequired} hidden={hideLabel}>
        {label}
      </Label>
      <div
        className={joinClassNames(
          styles.textInput,
          !hideLabel && styles.hasLabel,
          sizeStyles[size],
          className
        )}
      >
        {startAdornment}
        <input id={id} {...props} />
        {endAdornment}
      </div>
    </div>
  );
};
